import { render, staticRenderFns } from "./ProdProcess.vue?vue&type=template&id=02583230&"
import script from "./ProdProcess.vue?vue&type=script&lang=ts&"
export * from "./ProdProcess.vue?vue&type=script&lang=ts&"
import style0 from "./ProdProcess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports